// Vendors
import React, { useEffect, useState } from 'react';
import { connectStats } from 'react-instantsearch-dom';
import classnames from 'classnames';

const ResultsFoundHeader = ({ nbHits }) => {
  const [inView, setInView] = useState(false);
  const classNames = classnames('section__header', {
    [`section__header--in-view`]: inView
  });

  useEffect(() => {
    setTimeout(() => {
      setInView(true);
    }, 1000);
  }, []);

  return (
    <header className={classNames}>
      <h2 className="section__title">
        <span>
          {nbHits === 1 ? `${nbHits} result found` : `${nbHits} results found`}
        </span>
      </h2>
    </header>
  );
};

export default connectStats(ResultsFoundHeader);
